import { render, staticRenderFns } from "./commodityTab.vue?vue&type=template&id=12d70c42"
import script from "./commodityTab.vue?vue&type=script&lang=js"
export * from "./commodityTab.vue?vue&type=script&lang=js"
import style0 from "./commodityTab.vue?vue&type=style&index=0&id=12d70c42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports